import {themeSlice} from './slice';

export * from './slice';
export * from './selectors';
export * from './actions';
export default themeSlice.reducer;
